import { CartesianCoordinate } from "./Coordinate";
import { EHotelType } from "./Module";

export interface DropCalibrationPoint {
  topLeft: CartesianCoordinate;
  topRight: CartesianCoordinate;
  bottomRight: CartesianCoordinate;
  bottomLeft: CartesianCoordinate;
}

export interface PlateType {
  id: number;
  plateTypeName: string;
  numberOfColumn: number;
  numberOfRow: number;
  footprint: EFootprint;
  slotHeight: ESlotHeight;
  numberOfWell: number;
  numberOfDropPerWell: number;
  pitchX: number;
  pitchY: number;
  wellCoordinates: CartesianCoordinate[];
  dropCoordinates: CartesianCoordinate[];
  dropCalibrationPoints: DropCalibrationPoint[];
  wellLimit: WellLimit;
}

export interface PlateTypeCalibration {
  calibrationPoints: DropCalibrationPoint[];
  footprint: EFootprint;
  slotHeight: ESlotHeight;
  plateBumpOnReturn: boolean;
  plateBumpWaypointName: string;
  platePresenceSensor: boolean;
  dropPositionSaving: boolean;
  wellLimit: WellLimit;
}

export enum EFootprint
{
  Unknown = 0,
  SBS = 1,
  Linbro = 2,
  Nextal = 4,
  Terazaki = 8,
}

export enum ESlotHeight
{
  Unknown = 0,
  HalfSlot = 1,
  OneSlot = 2,
  OneHalfSlot = 3,
  TwoSlot = 4
}

export interface WellLimit {
  min: CartesianCoordinate;
  max: CartesianCoordinate;
}
